import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  User,
  FileText,
  BookOpen,
  Image,
  Users,
  ClipboardList,
  ArrowRight,
  DollarSign,
  Trophy
} from 'lucide-react';

const AdmissionsDashboard = () => {
  const cards = [
    {
      title: 'Profile & Info',
      description: 'Manage your institution profile and contact information',
      icon: User,
      href: '/coaching-admin/admissions/profile',
      color: 'bg-blue-500'
    },
    {
      title: 'Application Form',
      description: 'Customize application fields and requirements',
      icon: FileText,
      href: '/coaching-admin/admissions/form',
      color: 'bg-green-500'
    },
    {
      title: 'Curriculum',
      description: 'Manage courses and programs offered',
      icon: BookOpen,
      href: '/coaching-admin/admissions/curriculum',
      color: 'bg-purple-500'
    },
    {
      title: 'Brochures & Posters',
      description: 'Upload marketing materials and images',
      icon: Image,
      href: '/coaching-admin/admissions/materials',
      color: 'bg-pink-500'
    },
    {
      title: 'Faculty',
      description: 'Manage faculty members and their profiles',
      icon: Users,
      href: '/coaching-admin/admissions/faculty',
      color: 'bg-indigo-500'
    },
    {
      title: 'Applications',
      description: 'View and manage student applications',
      icon: ClipboardList,
      href: '/coaching-admin/admissions/applications',
      color: 'bg-orange-500'
    },
    {
      title: 'Admission Test',
      description: 'Configure and manage offline admission tests',
      icon: FileText,
      href: '/coaching-admin/admissions/tests',
      color: 'bg-red-500'
    },
    {
      title: 'Fee Structure',
      description: 'Manage fee structure - tabular entries or PDF upload',
      icon: DollarSign,
      href: '/coaching-admin/admissions/fee-structure',
      color: 'bg-emerald-500'
    },
    {
      title: 'Our Results',
      description: 'Manage results year-wise with exam switching',
      icon: Trophy,
      href: '/coaching-admin/admissions/results',
      color: 'bg-yellow-500'
    }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Admissions Management</h1>
        <p className="text-gray-600 dark:text-gray-400 mt-2">
          Manage your institution's admissions process and information
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {cards.map((card, index) => {
          const Icon = card.icon;
          return (
            <motion.div
              key={card.href}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <Link
                to={card.href}
                className="block bg-white dark:bg-gray-800 rounded-lg shadow-md hover:shadow-xl transition-shadow p-6 group"
              >
                <div className={`${card.color} w-12 h-12 rounded-lg flex items-center justify-center mb-4`}>
                  <Icon className="text-white w-6 h-6" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                  {card.title}
                </h3>
                <p className="text-gray-600 dark:text-gray-400 mb-4">
                  {card.description}
                </p>
                <div className="flex items-center text-blue-600 dark:text-blue-400 group-hover:translate-x-2 transition-transform">
                  <span className="text-sm font-medium">Manage</span>
                  <ArrowRight className="ml-2 w-4 h-4" />
                </div>
              </Link>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default AdmissionsDashboard;

